import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const SelectionListIcon = memo(() => (
    <IconWrapper>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M5.925 17.575 3.3 14.95l.475-.475L5.9 16.6l4.25-4.25.475.5zm0-7L3.3 7.95l.475-.475L5.9 9.6l4.25-4.25.475.5zm7.1 5.275v-.7h7.7v.7zm0-7v-.7h7.7v.7z"
            />
        </svg>
    </IconWrapper>
));
